<script>
import AddPaymentEventForm from '@/components/AddPaymentEventForm.vue'
import CardDialog from '@/components/dialogs/CardDialog.vue'
import MarkExpenseAsFullyPaid from '@/components/entryCard/MarkExpenseAsFullyPaid.vue'
import DemoModeInformer from '@/components/registration/DemoModeInformer.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'MarkAsPaidDialog',
  components: {
    AddPaymentEventForm,
    MarkExpenseAsFullyPaid,
    DemoModeInformer,
    CardDialog
  },
  props: {
    entry: {
      /** @type {import('vue').PropType<EntryResource>} */
      type: Object,
      required: true
    }
  },
  emits: ['close', 'success', 'error'],
  data: () => ({
    isSaving: false
  }),
  computed: {
    ...mapGetters('app', ['isTlpService']),
    ...mapGetters('companyData', ['isInDemoMode']),
    showFullyPaidForm() {
      return this.entry.type === 'expense' && this.isTlpService
    },
    isInvoice() {
      return this.entry.entry_type === 'INVOICE'
    }
  },
  methods: {
    onAddedPayment() {
      this.$emit('success')
      this.$emit('close')
    },
    submit() {
      this.isSaving = true
      this.$refs.form.submitPaymentEvent()
    },
    onError() {
      this.isSaving = false
      this.$emit('error')
    }
  }
}
</script>

<template>
  <CardDialog
    :title="$t('entries.actions.mark-as-paid')"
    :loading="isSaving"
    @action="submit"
    @close="$emit('close')"
  >
    <DemoModeInformer v-if="isInDemoMode" @close="$emit('close')">
      {{ $t('registration_flow.notification.info_payment_event') }}
    </DemoModeInformer>

    <MarkExpenseAsFullyPaid
      v-if="showFullyPaidForm"
      ref="form"
      :entry
      @error="onError"
      @cancel="$emit('close')"
      @success="onAddedPayment"
    />
    <AddPaymentEventForm
      v-else
      ref="form"
      :entry
      @error="onError"
      @success="onAddedPayment"
    />

    <template #action>
      {{ $t('entries.actions.mark-as-paid') }}
    </template>
  </CardDialog>
</template>
